import React from 'react';
import { MdEmail, MdPhone } from 'react-icons/md';
import { FaFacebookF, FaInstagram } from 'react-icons/fa';
import logo from '../assets/images/vraLogo.png'; // replace with your actual logo path

function Footer() {
  return (
    <footer className="bg-[#fdf4e4] text-[#3f3a32] py-10 px-6 md:px-20 text-center">
      {/* Logo */}
      <div className="flex justify-center mb-4">
        <img src={logo} alt="VR Archives Studio Logo" className="w-16 md:w-20 h-auto" />
      </div>

      {/* Main Title */}
      <h2 className="text-xl md:text-2xl font-bold font-mortend">
        A VR ARCHIVES PRODUCTION
      </h2>

      {/* Subtitle */}
      <p className="text-sm  md:text-sm  mt-2 mb-6">
        Bringing history to life through virtual reality. 
      </p>

      {/* Contact + Socials */}
      <div className="flex flex-col md:flex-row justify-center gap-6 md:gap-16 items-center text-sm md:text-base mb-8">
        {/* Left (Email & Phone) */}
        <div className="space-y-2 text-left">
          <div className="flex items-center gap-2 mb-2">
            <MdEmail className="text-lg" />
            <a href="mailto:info@sigiriyavr.com" className="underline hover:text-[#7c623f]">
              info@sigiriyavr.com
            </a>
          </div>
          <a href="https://wa.me/94741100816" target="_blank" rel="noopener noreferrer">
          <div className="flex items-center gap-2">
            <MdPhone className="text-lg" />
            <span>+94 741 100 816</span>
          </div>
          </a>
        </div>

        {/* Right (Socials) */}
        <div className="space-y-2 text-left">
        <a href="https://www.instagram.com/sigiriya.vr" target='_blank' rel="noopener noreferrer">
          <div className="flex items-center gap-2 mb-2">
            <FaInstagram className="text-lg" />
            <span>Instagram</span>
          </div>
          </a>
          <a href="https://www.facebook.com/profile.php?id=61571809851156&rdid=ncyU8oFlhunX6zZn&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1FKtZ4xgQd" target='_blank' rel='noreferrer'>
          <div className="flex items-center gap-2">
            <FaFacebookF className="text-lg" />
            <span>Facebook</span>
          </div>
          </a>
        </div>
      </div>

      {/* Footer Bottom */}
      <p className="text-xs md:text-sm ">
        © 2025 VR Archives Studio. All rights reserved.
      </p>
    </footer>
  );
}

export default Footer;
